<template>
  <div class="rt-typeahead-wrapper tw-max-w-xs tw-flex " :class="{ 'typeahead-off': !hasFocus }">
    <div class="tw-flex tw-mt-1 tw-relative rt-typeahead-container">
      <div class="tw-px-2 tw-flex tw-py-1 tw-align-middle tw-items-center" @click="focusOnSearch">
        <rb icon="search" class="tw-p-2 tw-font-bold" id="typahead-search-icon"/>
      </div>
      <b-tooltip :show="noResult" triggers="" target="typahead-search-icon" placement="bottomright">
        {{ $t('errors.typahead_no_result') }}
      </b-tooltip>
      <input size="md"
        type="text"
        class="rt-typeahead-input"
        :placeholder="whereCalling"
        ref="typeaheadInput"
        autocomplete="off"
        :value="query"
        @keyup.down="down"
        @keyup.up="up"
        @keyup.enter="hit"
        @keyup.esc="reset"
        @blur="onBlur"
        @input="update"
        @focus="onFocus"
      >
      <div v-if="isDirty" class="tw-flex tw-items-center">
        <a @click="clear()"><rb icon="cancel-circle" class="tw-p-2" /></a>
      </div>
    </div>
    <ul v-show="hasItems">
      <li v-for="item in items" :key="item.id" class="tw-flex" :class="activeClass(items.indexOf(item))" @mousedown="hit(items.indexOf(item))" @mousemove="setActive(items.indexOf(item))">
        <span class="name"><flag size="xs" :iso="item.id" /> {{ countryName(item.id) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Translation } from '@/utils/Translation'

export default {

  data () {
    return {
      limit: 10,
      minChars: 1,
      items: [],
      query: '',
      current: -1,
      selectFirst: true,
      hasFocus: false
    }
  },

  computed: {
    ...mapGetters({
      'findCountryByToken': 'app/findCountryByToken'
    }),
    hasItems () {
      return this.items.length > 0
    },
    isEmpty () {
      return !this.query
    },
    isDirty () {
      return !!this.query
    },
    noResult () {
      return this.isDirty && !this.hasItems && this.hasFocus && this._querySearchIsValid(this.query)
    },
    whereCalling () {
      return this.$t('label.where_calling')
    }
  },
  methods: {
    ...mapActions({
      'loadCountries': 'app/loadCountries'
    }),
    onFocus () {
      this.hasFocus = true
      this.$emit('typeaheadFocusChanged', true)
      this.update()
    },
    onBlur () {
      this.hasFocus = false
      this.$emit('typeaheadFocusChanged', false)
      this.reset()
      this.clear()
    },
    countryName (iso) {
      return this.$t('countries.' + iso.toUpperCase())
    },
    update (event) {
      if (event) {
        this.query = event.target.value
      }
      if (!this._querySearchIsValid(this.query)) {
        this.reset()
        return
      }

      if (!this._hasMinimumCharacters(this.minChars, this.query)) {
        return
      }

      this.items = this.findCountryByToken(this.query, this.limit)
      this.current = -1

      if (this.selectFirst) {
        this.down()
      }
    },

    cancel () {
      // used to 'cancel' previous searches
    },

    reset () {
      this.items = []
    },

    clear () {
      this.items = []
      this.query = ''
      this.current = -1
    },

    setActive (index) {
      this.current = index
    },

    activeClass (index) {
      return {
        active: this.items[this.current] === this.items[index]
      }
    },

    hit (e) {
      let resultIndex = typeof e === 'number' ? e : this.current

      if (this.current !== -1) {
        this.onHit(this.items[resultIndex].id)
      }
    },

    up () {
      if (this.current > 0) {
        this.current--
      } else if (this.current === -1) {
        this.current = this.items.length - 1
      } else {
        this.current = -1
      }
    },

    down () {
      if (this.current < this.items.length - 1) {
        this.current++
      } else {
        this.current = -1
      }
    },
    onHit (id) {
      let locale = Translation.currentLanguage
      let url = process.env.WWW_URL + '/'
      if (locale === 'es') {
        url += locale + '/tarifas/?tocountry=' + id
      } else if (locale === 'fr') {
        url += locale + '/tarifs/?tocountry=' + id
      } else {
        url += 'en/rates/?tocountry=' + id
      }

      window.location.href = url
    },
    focusOnSearch (e) {
      this.hasFocus = true
      this.$refs.typeaheadInput.focus()
    },

    //  Private methods
    _querySearchIsValid (query) {
      return query && query.trim().length !== 0
    },
    _hasMinimumCharacters (minimumCharacters, query) {
      if (!minimumCharacters) {
        return true
      }

      return query && query.trim().length >= minimumCharacters
    }
  },
  async created () {
    await this.loadCountries(this.$route.params.locale)
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables/variables.scss";
@import "@/assets/styles/bootstrap/_mixins.scss";

@include media-breakpoint-down(sm) {
  .typeahead-on .rt-typeahead-wrapper {
    @apply tw-px-0.5;
    background: white;
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index: 99999;
    max-width: 100%;
  }
  .typeahead-on .rt-typeahead-container {
    width: 100%;
  }

  .typeahead-on input {
    width:100%;
    font-size:inherit;
  }
  .rt-typeahead-wrapper {
    font-size: 1.5rem;
  }
  input {
    font-size:inherit;
  }
}
input {
  font-size: 1.125rem;
}

input:focus {
  outline: 0;
}

.fa-times {
  cursor: pointer;
}

ul {
  position: absolute;
  padding: 0;
  min-width: 300px;
  background-color: #fff;
  list-style: none;
  border-radius: 0;
  border: 1px solid #ccc;
  z-index: 1000;
  top:100%;
  li {
    padding: 10px 16px;
    border-bottom: 1px solid #ccc;
    cursor: pointer;

    .name {
      display: flex;
      align-items: center;

      i {
        margin-right: 1rem;
        vertical-align: bottom;
      }
    }
    // &:first-child {
    //   border-top: 0;
    // }
    &:last-child {
      border-bottom: 0;
    }
  }
}

.active span {
  color: #e3232c;
}

$typeaheadPlaceholder: var(--theme-color-gray-darker);

.rt-typeahead-input {
  color: $typeaheadPlaceholder;

  &::-webkit-input-placeholder {
    color: $typeaheadPlaceholder;
  }
  &::-moz-placeholder {
    color: $typeaheadPlaceholder;
  }
  &:-ms-input-placeholder {
    color: $typeaheadPlaceholder;
  }
  &:-moz-placeholder {
    color: $typeaheadPlaceholder;
  }
}

$typeaheadTransparent: transparent;

@include media-breakpoint-down(sm) {
.typeahead-off {
  input {
    color: $typeaheadTransparent;

    &::-webkit-input-placeholder {
      color: $typeaheadTransparent;
    }
    &::-moz-placeholder {
      color: $typeaheadTransparent;
    }
    &:-ms-input-placeholder {
      color: $typeaheadTransparent;
    }
    &:-moz-placeholder {
      color: $typeaheadTransparent;
    }
  }
}
}

</style>



// WEBPACK FOOTER //
// src/components/TheNavbarTypeahead.vue